import * as React from 'react';
import { AdminLandmarkDto, AdminOptionDto } from 'services/data-contracts';
import styled from 'styled-components';

const LandmarkCard = ({
  landmark,
  onClick,
}: {
  landmark: AdminLandmarkDto;
  onClick: () => void;
}) => {
  return (
    <CardContainer onClick={onClick}>
      {landmark?.images?.[0]?.url && (
        <WineImage
          loading="lazy"
          src={landmark?.images?.[0]?.url}
          alt={landmark.localizedName?.ko}
        />
      )}
      <ContentWrapper>
        <ContentInner>
          <CardContent>
            <ProductInfo>
              <TitleSection>
                <ProductTitle>{landmark.localizedName?.ko}</ProductTitle>
              </TitleSection>
              <Divider
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/90d196bd1523e9f7d20e0173a0b1095eeaa4460afc2bbd9aa4fd3171b314ae1f?apiKey=3721b445ce6f47eaaa05786c3675d5db&"
                alt="divider"
              />
              <DescriptionSection>
                <ShortDescription
                  dangerouslySetInnerHTML={{
                    __html:
                      (landmark.localizedDesc?.ko || '').length > 100
                        ? (landmark.localizedDesc?.ko || '').slice(0, 100) + '...'
                        : landmark.localizedDesc?.ko || '',
                  }}
                />
              </DescriptionSection>
            </ProductInfo>
          </CardContent>
        </ContentInner>
      </ContentWrapper>
    </CardContainer>
  );
};

const CardContainer = styled.div`
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid var(--Grayscale-20, #e4e4e4);
  background: var(--Grayscale-0, #fff);
  display: flex;
  max-width: 350px;
  justify-content: start;
  flex-wrap: wrap;
  flex-direction: column;
  cursor: pointer;
`;

const WineImage = styled.img`
  aspect-ratio: 1.32;
  object-fit: cover;
  object-position: center;
  width: 100%;
  border-radius: 12px 12px 0 0;
  min-width: 240px;
`;

const ContentWrapper = styled.div`
  display: flex;
  min-width: 240px;
  flex: 1;
  flex-basis: 0%;
  padding: 24px 0 16px;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const ContentInner = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
  justify-content: start;
  flex: 1;
  height: 100%;
  padding: 0 20px;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const CardContent = styled.div`
  display: flex;
  min-width: 240px;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  flex-basis: 0%;
`;

const ProductInfo = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: Pretendard, sans-serif;
  justify-content: start;
`;

const TitleSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  color: var(--Grayscale-90, #1d1d1d);
  justify-content: start;
`;

const ProductTitle = styled.h2`
  font-size: 17px;
  font-weight: 500;
  letter-spacing: -0.04px;
  margin: 0;
  cursor: pointer;
`;

const PriceContainer = styled.div`
  display: flex;
  margin-top: 16px;
  min-height: 13px;
  width: 100%;
  align-items: center;
  font-weight: 600;
  white-space: nowrap;
  justify-content: start;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const PriceWrapper = styled.div`
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: start;
  margin: auto 0;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const Price = styled.span`
  font-size: 19px;
  letter-spacing: -0.05px;
  align-self: stretch;
  margin: auto 0;
`;

const Divider = styled.img`
  aspect-ratio: 500;
  object-fit: contain;
  object-position: center;
  width: 100%;
  stroke-width: 1px;
  stroke: var(--Grayscale-10, #f0f0f0);
`;

const DescriptionSection = styled.div`
  display: flex;
  margin-top: 20px;
  width: 100%;
  flex-direction: column;
  font-size: 13px;
  color: var(--Grayscale-70, #555);
  font-weight: 400;
  letter-spacing: -0.03px;
  justify-content: start;
`;

const ShortDescription = styled.p`
  margin: 0;
`;

export default LandmarkCard;
